<template>
    <button ref="button" class="action-button interactive" :class="[{ focus, jump, disabled }, variation, size]">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'custom-button',
    props: {
        variation: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: 'medium'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focus: false,
            jump: true,
            lastFocusedTimestamp: null
        }
    },
    methods: {
        async handleClick() {
            if(!this.focus) return
            await new Promise(r => setTimeout(r, 100));
            if("vibrate" in navigator) {
                try {
                    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;                        
                    if (navigator.vibrate) { 
                        navigator.vibrate(100);
                    }
                } catch(error) {}
            }
            this.$emit('click');
        },
        handleFocus() {
            this.lastFocusedTimestamp = Date.now();
            this.focus = true;
            this.jump = true;
        },
        async handleUnfocus(targetElement) {
            const button = this.$refs.button;
            if(!button.contains(targetElement)) return this.focus = false;

            this.jump = true;
            const milisecondsToWait = this.lastFocusedTimestamp + 100 - Date.now();
            if(milisecondsToWait > 0) await new Promise(r => setTimeout(r, milisecondsToWait));
            this.focus = false;
            await new Promise(r => setTimeout(r, 250));
            this.jump = false;
        },
        handleTargetElement(event) {
            const target = event.target;
            const button = this.$refs.button;
            if(button.contains(target)) this.handleFocus();
        },
        async handleTargetElementMoved() {
            if(!this.focus) return
            
            this.jump = false;
            this.focus = false;
        },
        async handleClickElement(targetElement) {
            const button = this.$refs.button;
            if(button.contains(targetElement)) this.handleClick();
            this.handleUnfocus(targetElement);
        }
    },
    mounted() {
        const vm = this;
        this.$root.$on('targetElement', vm.handleTargetElement);
        this.$root.$on('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$on('clickElement', vm.handleClickElement);
    },
    beforeDestroy() {
        const vm = this;
        this.$root.$off('targetElement', vm.handleTargetElement);
        this.$root.$off('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$off('clickElement', vm.handleClickElement);
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.action-button {
    width: 100%;
    border: none;
    opacity: 1;
    font-weight: 700;
    color: black;
    box-shadow: 0 2px 6px -2px #00000070;
    user-select: none;

    &.small {
        font-size: 14px;
        padding: .3em .6em;
        border-radius: 12px;
    }

    &.medium {
        font-size: 16px;
        padding: .4em .8em;
        border-radius: 12px;
    }
    
    &.large {
        font-size: 18px;
        padding: 0.4em .8em;
        border-radius: 18px;
    }
    
    &.primary {
        background: linear-gradient(171deg, #4B9E09 0% 49%, #459108 51% 100%);
        color: #f1f1f1;
    }
    &.white {
        background: linear-gradient(171deg, #f1f1f1 0% 49%, #e0e0e0 51% 100%);
        color: #2f343a;
    }
    &.grey {
        background: linear-gradient(171deg, #9e9e9e 0% 49%, #8c8c8c 51% 100%);
        color: #2f343a;
    }
    &.danger {
        background: linear-gradient(171deg, #9f0101 0% 49%, #7f0202 51% 100%);
        color: #f1f1f1;
    }

    &.disabled {
        pointer-events: none;
        opacity: 0.7;
    }
}

.interactive {
    scale: 1;
    
    &.jump {
        transition: all .3s ease, scale 250ms cubic-bezier(.51,7,.45,1.08);
    }

    &.focus {
        scale: 0.97;
        transition: 200ms ease;
    }
}

</style>